export default `
    <link href='/snippets-style/style.css' rel='stylesheet' />
    <p>At FavBet deposit and withdrawal transactions are made quickly and securely. All you need is a user account to enjoy our services and products. Deposit, win and withdraw without any commission!</p>
    <a href="/deposit-skrill" style="margin-right: 10px"><img src="/images/snippetsMedia/payments/skrill_logo.png" alt="skrill-payment" class="payments-img"></a>
    <a href="/deposit-neteller"><img src="/images/snippetsMedia/payments/neteller_logo.png" alt="neteller-payment" class="payments-img"></a>
`;
